import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule, Optional, SkipSelf } from '@angular/core';

import { DialogModule } from '@ngneat/dialog';
import { TranslateService } from '@ngx-translate/core';
import { NgxsModule } from '@ngxs/store';
import { SocialLoginModule } from 'angularx-social-login';

import { MandatoryParamsGuard } from './guards/mandatory-params/mandatory-params.guard';
import { AbsuidService } from './services/absuid/absuid.service';
import { GoogleTagManagerService } from './services/analytics/google-tag-manager.service';
import {
  AppConfigService,
  loadInitialData,
} from './services/app-config/app-config.service';
import { ErrorReportService } from './services/error-report/error-report.service';
import { OfferService } from './services/offer/offer.service';
import { ReservationService } from './services/reservation/reservation.service';
import { SessionEventsService } from './services/session-events/session-events.service';
import { UserService } from './services/user/user.service';
import { AppState } from './states/app-state/app.state';
import { AuthState } from './states/auth-state/auth.state';
import { BookingState } from './states/booking-state/booking.state';
import { CalculatedPriceState } from './states/calculated-price-state/calculated-price.state';
import { OfferState } from './states/offer-state/offer.state';
import { ReservationState } from './states/reservation-state/reservation.state';
import { TripState } from './states/trip-state/trip.state';
import { VehicleState } from './states/vehicle-state/vehicle.state';
import { DIALOG_SIZES } from './utils/dialog.config';
import { SOCIAL_AUTH_SERVICE_CONFIG } from './utils/social-login.config';

@NgModule({
  imports: [
    HttpClientModule,
    NgxsModule.forFeature([
      AppState,
      BookingState,
      OfferState,
      CalculatedPriceState,
      TripState,
      AuthState,
      VehicleState,
      ReservationState,
    ]),
    DialogModule.forRoot(DIALOG_SIZES),
    SocialLoginModule,
  ],
  providers: [
    MandatoryParamsGuard,
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: loadInitialData,
      deps: [AppConfigService, TranslateService],
      multi: true,
    },
    {
      provide: 'SocialAuthServiceConfig',
      useValue: SOCIAL_AUTH_SERVICE_CONFIG,
    },
    OfferService,
    AbsuidService,
    UserService,
    ReservationService,
    GoogleTagManagerService,
    ErrorReportService,
    SessionEventsService,
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only'
      );
    }
  }
}
